import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractRevokedTemplates = [
  {
    id: '-108001',
    language: Language.EN,
    subject: 'End of lease date updated',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REVOKED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: end date update of the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Your lease contract will end on: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <ul>
        <li>Ended by: <strong>{{getInitiator leaseActionHistory language}}</strong></li>
        {{#if (hasComment leaseActionHistory)}}
        <li>Comment: <i>{{leaseActionHistory.comment}}</i></li>
        {{/if}}
        {{#if (hasCompensation leaseActionHistory)}}
        <li>Compensation: <strong>{{leaseActionHistory.totalAmount}} €</strong> - this compensation will be added to the last {{getInvoiceOrPaymentRequest lease}}.</li>
        {{/if}}
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-108002',
    language: Language.FR,
    subject: 'Mise à jour de la date de fin du bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REVOKED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: mise à jour de la date de fin du bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Votre bail prendra fin le: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <ul>
        <li>Cloturé par: <strong>{{getInitiator leaseActionHistory language}}</strong></li>
        {{#if (hasComment leaseActionHistory)}}
        <li>Commentaire: <i>{{leaseActionHistory.comment}}</i></li>
        {{/if}}
        {{#if (hasCompensation leaseActionHistory)}}
        <li>Indemnité: <strong>{{leaseActionHistory.totalAmount}} €</strong> - cette indemnité sera reprise sur votre dernière {{getInvoiceOrPaymentRequest lease}}.</li>
        {{/if}}
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-108003',
    language: Language.NL,
    subject: 'De einddatum van uw huurcontract werd aangepast',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REVOKED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: aanpassing van de einddatum van uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Uw huurcontract eindigt op: <strong>{{formatDate lease.endDate}}</strong></p>
        <ul>
        <li>Beëindigd door: <strong>{{getInitiator leaseActionHistory language}}</strong></li>
        {{#if (hasComment leaseActionHistory)}}
        <li>Opmerking: <i>{{leaseActionHistory.comment}}</i></li>
        {{/if}}
        {{#if (hasCompensation leaseActionHistory)}}
        <li>Compensatie: <strong>{{leaseActionHistory.totalAmount}} €</strong> - deze compensatie wordt toegevoegd aan je laatste {{getInvoiceOrPaymentRequest lease}}.</li>
        {{/if}}
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-108004',
    language: Language.DE,
    subject: 'Enddatum des Mietvertrags aktualisiert',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REVOKED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Aktualisierung des Enddatums des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Ihr Mietvertrag endet am: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <ul>
        <li>Beendet von: <strong>{{getInitiator leaseActionHistory language}}</strong></li>
        {{#if (hasComment leaseActionHistory)}}
        <li>Kommentar: <i>{{leaseActionHistory.comment}}</i></li>
        {{/if}}
        {{#if (hasCompensation leaseActionHistory)}}
        <li>Entschädigung: <strong>{{leaseActionHistory.totalAmount}} €</strong> - diese Entschädigung wird zu Ihrer letzten {{getInvoiceOrPaymentRequest lease}} hinzugefügt.</li>
        {{/if}}
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
